import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { toast } from 'react-toastify';

import {
  ErrorCode,
  ErrorDataType,
  ErrorType,
  useAppStorage
} from '~store/useStore';
import './errorBoundaryBack.scss';

const ErrorBoundaryBack = ({ children }: React.PropsWithChildren) => {
  const { t } = useTranslation();
  const { errorRequest, cleanError } = useAppStorage();

  const validateError = (error: ErrorType) => {
    const errorCode = error as ErrorCode;
    if (errorCode.code !== 'token_not_valid') {
      //* Show toast if error is not an HTML
      if (typeof error !== 'string') {
        const errors = Object.values(error);
        errors.map((singularError: string) => toast.error(t(singularError)));
      } else toast.error(t('toasts.request_error'));
      cleanError();
    }
    return error;
  };

  useEffect(() => {
    if (errorRequest) {
      const errorDataRequest = errorRequest as ErrorDataType;
      if (errorDataRequest?.data) {
        validateError(errorDataRequest.data);
      } else {
        validateError(errorRequest);
      }
    }
  }, [errorRequest]);

  return children;
};

export default ErrorBoundaryBack;
